var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "#101820",
  stroke: "#101820",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 7.5,
  r: 3.5,
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5 18v1h15v-1a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4Z"
})));
export default SvgUserFilled;